import React, { useState, useRef, useEffect } from "react";
import {
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
  Modal,
  TextInput,
} from "react-native";

import { useTranslation } from "react-i18next";
import { useToast } from "../contexts/ToastContext";

import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import GlobalStyles from "../../Resources/Styles";

import { useScreenDimensions, useDevice } from "../_layout";

const SendFeedback = ({
  isVisible,
  onClose,
  coach,
  titleKey = "sendFeedback-string",
  textKey = "feedbackText-string",
  placeholderKey = "sendFeedbackPlaceholder-string",
  source = null,
}) => {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const { screenWidth, screenHeight, ultraWideScreen, screenSize } =
    useScreenDimensions();
  const [string, setString] = useState("");
  const { isMobile } = useDevice();
  const textInputRef = useRef(null);

  useEffect(() => {
    if (isVisible && textInputRef.current) {
      // Small delay to ensure modal is fully rendered
      setTimeout(() => {
        textInputRef.current?.focus();
      }, 100);
    } else {
      // Reset text when modal closes
      setString("");
    }
  }, [isVisible]);

  const handleChange = (text) => {
    setString(text);
  };

  const [isHovered, setIsHovered] = useState(false);

  const [isButtonHovered, setIsButtonHovered] = useState(false);

  const handleSendFeedback = async () => {
    const trimmedFeedback = string.trim();
    if (!trimmedFeedback) return;

    if (coach?.uploadFeedbackFirestore) {
      try {
        await coach.uploadFeedbackFirestore(trimmedFeedback, source);
        showToast("feedbackThanksTitle-string", {
          type: "info",
          description: "feedbackThanksDescription-string",
        });
      } catch (error) {
        console.error("Error uploading feedback:", error);
      }
    }

    onClose();
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={() => onClose()}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={() => onClose()}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{ position: "absolute" }}
          onStartShouldSetResponder={() => false}
        >
          <View
            style={[
              styles.modalView,
              {
                maxHeight: "90%",
                maxWidth: screenSize != "small" ? 380 : "90%",
                alignSelf: "center",
                padding: 24,
              },
            ]}
          >
            <Text style={[Fonts.bold18, { marginBottom: 10 }]}>
              {t(titleKey)}
            </Text>
            <Text>
              {t(textKey, {
                coachName:
                  coach?.name && coach.name !== "" ? coach.name : "Coach",
              })}
            </Text>
            <TextInput
              ref={textInputRef}
              value={string}
              onChangeText={handleChange}
              multiline
              numberOfLines={7}
              placeholder={t(placeholderKey)}
              placeholderTextColor={Colors.grayColor}
              style={{
                width: "100%",
                marginVertical: 16,
                height: 80,
                borderRadius: 12,
                borderWidth: 0.1,
                borderColor: isHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
                paddingVertical: 7,
                paddingHorizontal: 10,
                outline: "none",
              }}
              maxLength={4000}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            />
            <View>
              <TouchableOpacity
                style={{
                  backgroundColor: Colors.bubbleColor,

                  borderRadius: 14,
                  borderWidth: 1,
                  justifyContent: "center",
                  borderColor: Colors.bubbleColor,
                  width: 80,
                  height: 35,
                  justifyContent: "center",
                  alignItems: "center",
                  alignSelf: "flex-end",
                  opacity: isButtonHovered || string === "" ? 0.7 : 1,
                }}
                disabled={string === ""}
                onPress={handleSendFeedback}
                onMouseEnter={() => !isMobile && setIsButtonHovered(true)}
                onMouseLeave={() => setIsButtonHovered(false)}
              >
                <Text
                  style={{
                    textAlignVertical: "center",
                    textAlign: "center",
                    color: Colors.whiteColor,
                  }}
                >
                  {t("send-string")}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
});

export default SendFeedback;
